import React from "react";
import { insideCallouts, insideFeatures } from "../data/content";
import { images, product } from "../data/product";
import { ImageSlot } from "./ui/ImageSlot";
import { Accent, SectionHeading } from "./ui/SectionHeading";
export function InsideRecipe() {
  return <section id="dentro" className="scroll-mt-16 bg-cream px-4 py-14 sm:px-6 sm:py-20" data-id="element-126" data-mp="2ptwyg1y69iaf">
      <SectionHeading title="Scopri cosa trovi all'interno" subtitle={`${product.volumesCount} volumi digitali per la cura della persona. Indicazioni chiare in ogni formula.`} data-id="element-127" data-mp="2kv3pmmttyfgl" />
      <div className="mx-auto mt-8 grid max-w-6xl gap-10 lg:grid-cols-[1.15fr_1fr] lg:items-center lg:gap-14" data-id="element-128" data-mp="1s6ofadln8lbl">
        <figure className="relative" data-id="element-129" data-mp="222j1tjszn0jn">
          {/* Sostituisci images.recipePage con una pagina autentica del tuo materiale */}
          <ImageSlot src={images.recipePage} alt="Esempio di pagina ricetta con foto, ingredienti in grammi e metodo" placeholderLabel="Pagina autentica del materiale" className="aspect-square w-full rounded-[28px]" data-id="element-130" data-mp="3hii5ahrnu8dk" />
          {insideCallouts.map(c => <span key={c.label} className={`absolute ${c.position} rounded-full bg-wine px-3 py-1.5 font-serif text-[13px] italic text-white shadow-md sm:px-4 sm:text-sm`} data-id="element-131" data-mp="1la1pxoxjj8jw">
              {c.label}
            </span>)}
        </figure>

        <div data-id="element-132" data-mp="xmlavnzadaaw">
          <h3 className="font-serif text-[28px] font-semibold leading-[1.15] text-wine sm:text-[36px]" data-id="element-133" data-mp="xn3bewszeaom">
            Dentro ognuna delle
            <span className="block" data-id="element-134" data-mp="11l12k56bb6un">
              <Accent italic data-id="element-135" data-mp="16m8ac48gg61b">{product.recipesText} ricette</Accent>
            </span>
          </h3>
          <ul className="mt-6" data-id="element-136" data-mp="1bdgk51dp5tf0">
            {insideFeatures.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-4 border-b border-line py-4 last:border-0" data-id="element-137" data-mp="dycef1qpmi5l">
                <Icon className="h-6 w-6 shrink-0 text-rose" strokeWidth={1.5} aria-hidden="true" data-id="element-138" data-mp="iw4b092ausg4" />
                <span className="text-[16px] font-semibold leading-snug text-wine" data-id="element-139" data-mp="1m709yer0lwif">{label}</span>
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}